module.exports = __webpack_public_path__ + "img/ai-logo-white.f460d1b6.png";